import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
import { ToasterService } from 'angular2-toaster';
import { of } from 'rxjs/observable/of';

import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth.service';
import { ProjectManagerService } from '../../../../services/project-manager.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { ProjectSaveService } from '../../../../services/project-save.service';
import { catchError, concatMap, delay, switchMap, take } from 'rxjs/operators';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { MatDialog } from '@angular/material';
import { ModalGetQuoteInfoComponent } from '../modal-get-quote-info/modal-get-quote-info.component';
import { ModalGetQuoteDealersComponent } from '../modal-get-quote-dealers/modal-get-quote-dealers.component';
import { AnalyticsService } from '../../../../services/analytics.service';
import { ModalGetQuoteProcessAuthorization } from '../modal-get-quote-process-authorization/modal-get-quote-process-authorization.component';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { ModalQuoteSent } from '../modal-quote-sent/modal-quote-sent.component';
import { AddonManagerService } from '../../../../services/addon-manager.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class GetQuoteService {
  private _showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }

  private _isAuthorized() {
    return this.authService.isAuthorization;
  }

  private _isNewProject() {
    return this.projectManagerService.projectExists(this.projectManagerService.project.id).pipe(
      switchMap(({ exists }) => {
        if (
          this.projectManagerService.ifCurrentProjIsSharedProj(
            this.projectManagerService.getCurrentProjectId()
          ) ||
          !this.projectManagerService.project.id ||
          (this.projectManagerService.project.id && !exists)
        ) {
          return of(true);
        }
        return of(false);
      })
    );
  }

  private _processAuthorization() {
    const processAuthorizationfoDialogRef = this.dialog.open(ModalGetQuoteProcessAuthorization, {
      width: '835px',
      // height: '75vh'
    });

    return processAuthorizationfoDialogRef.afterClosed().pipe(
      switchMap(() => {
        const user = this.authService.getUser();
        if (!user) return ErrorObservable.create('Warning user is not logged in');
        return of({});
      })
    );
  }

  private _processAfterAuthorization(isNewProject: boolean) {
    this.loadingSpinnerService.spinnerLoadingListAdd('processAfterAuthorizationGetQuoteService');

    return (
      isNewProject
        ? this.projectManagerService.getNewProjectName()
        : of(this.projectManagerService.project.projectName)
    ).pipe(
      concatMap(projectName => {
        if (!projectName) return ErrorObservable.create('Error project name undefined');
        return this.projectSaveService.save(projectName, isNewProject);
      }),
      concatMap(() => {
        this.loadingSpinnerService.spinnerLoadingListRemove(
          'processAfterAuthorizationGetQuoteService'
        );
        const getQuoteInfoDialogRef = this.dialog.open(ModalGetQuoteInfoComponent, {
          width: '700px'
          // width: '455px'
        });
        return getQuoteInfoDialogRef.afterClosed().pipe(
          switchMap(res => {
            if (!res.dealer) {
              return ErrorObservable.create('Warning no dealer chosen');
            }
            return of({ ...res });
          })
        );
      }),
      // concatMap(res => {
      //   console.log('res', res);
      //   if (res && res.zipCode && res.dealers && res.dealers.length) {
      //     const getQuoteDealersDialogRef = this.dialog.open(ModalGetQuoteDealersComponent, {
      //       width: '700px',
      //       data: {
      //         getAddress: this.getAddress.bind(this),
      //         dealers: res.dealers,
      //         comments: res.comments,
      //         projectUrl: `${environment.appUrl}/browsing/${this.projectManagerService.project.id}`,
      //         zipCode: res.zipCode,
      //         coords: res.coords
      //       }
      //     });
      //
      //     return getQuoteDealersDialogRef.afterClosed().pipe(
      //       switchMap(dealerChosenRes => {
      //         if (!dealerChosenRes.dealer) {
      //           return ErrorObservable.create('Warning no dealer chosen');
      //         }
      //         return of({ ...res, ...{ dealer: dealerChosenRes.dealer } });
      //       })
      //     );
      //   }
      //   return ErrorObservable.create('Warning no zip code or dealers');
      // }),
      concatMap(res => {
        console.log('res ModalQuoteSent service', res);
        const country =
          res.dealer &&
          res.dealer.values &&
          this.getAddress(res.dealer.values, 'country') &&
          this.getAddress(res.dealer.values, 'country')[0] &&
          this.getAddress(res.dealer.values, 'country')[0]['text']
            ? this.getAddress(res.dealer.values, 'country')[0]['text']
            : '';

        const state =
          res.dealer &&
          res.dealer.values &&
          this.getAddress(res.dealer.values, 'state') &&
          this.getAddress(res.dealer.values, 'state')[0] &&
          this.getAddress(res.dealer.values, 'state')[0]['text']
            ? this.getAddress(res.dealer.values, 'state')[0]['text']
            : '';

        const city = this.getAddress(res.dealer.values, 'city');
        const address1 = this.getAddress(res.dealer.values, 'address1');
        let dealerAddress = null;
        if (country && city && state && address1) {
          dealerAddress = `${country}, ${city}, ${state}, ${address1}`;
        }
        console.log('next this.dialog.open');
        this.dialog.open(ModalQuoteSent, {
          width: '400px',
          data: {
            dealerCompanyName: res.dealer.values.companyname,
            dealerAddress
          }
        });
        console.log('next analyticsService.onUserCreatedQuote');
        this.analyticsService.onUserCreatedQuote(
          this.projectManagerService.project.id,
          res.dealer,
          res.comments
        );
        return of(true);
      })
    );
  }

  private _processAfterAuthorizationForAddon() {
    this.loadingSpinnerService.spinnerLoadingListAdd('processAfterAuthorizationGetQuoteServiceForAddon');
    return (of(this.addonManagerService.addonProject.projectName)).pipe(
      concatMap(() => {
        this.loadingSpinnerService.spinnerLoadingListRemove(
          'processAfterAuthorizationGetQuoteServiceForAddon'
        );
        const getQuoteInfoDialogRef = this.dialog.open(ModalGetQuoteInfoComponent, {
          width: '700px',
          // width: '455px',
          data: { projectType: 'interior' }
        });
        return getQuoteInfoDialogRef.afterClosed().pipe(
          switchMap(res => {
            if (!res.dealer) {
              return ErrorObservable.create('Warning no dealer chosen');
            }
            return of({ ...res });
          })
        );
      }),
      concatMap(res => {
        // console.log('res ModalQuoteSent service', res);
        const country =
          res.dealer &&
          res.dealer.values &&
          this.getAddress(res.dealer.values, 'country') &&
          this.getAddress(res.dealer.values, 'country')[0] &&
          this.getAddress(res.dealer.values, 'country')[0]['text']
            ? this.getAddress(res.dealer.values, 'country')[0]['text']
            : '';

        const state =
          res.dealer &&
          res.dealer.values &&
          this.getAddress(res.dealer.values, 'state') &&
          this.getAddress(res.dealer.values, 'state')[0] &&
          this.getAddress(res.dealer.values, 'state')[0]['text']
            ? this.getAddress(res.dealer.values, 'state')[0]['text']
            : '';

        const city = this.getAddress(res.dealer.values, 'city');
        const address1 = this.getAddress(res.dealer.values, 'address1');
        let dealerAddress = null;
        if (country && city && state && address1) {
          dealerAddress = `${country}, ${city}, ${state}, ${address1}`;
        }
        this.dialog.open(ModalQuoteSent, {
          width: '400px',
          data: {
            dealerCompanyName: res.dealer.values.companyname,
            dealerAddress
          }
        });
        this.analyticsService.onUserCreatedQuote(
          this.projectManagerService.project.id,
          res.dealer,
          res.comments
        );
        return of(true);
      })
    );
  }

  // private _processAfterAuthorization(isNewProject: boolean) {
  //   this.loadingSpinnerService.spinnerLoadingListAdd('processAfterAuthorizationGetQuoteService');
  //
  //   return (
  //     isNewProject
  //     ? this.projectManagerService.getNewProjectName()
  //     : of(this.projectManagerService.project.projectName)
  //   ).pipe(
  //     concatMap(projectName => {
  //       if (!projectName) return ErrorObservable.create('Error project name undefined');
  //       return this.projectSaveService.save(projectName, isNewProject);
  //     }),
  //     concatMap(() => {
  //       this.loadingSpinnerService.spinnerLoadingListRemove(
  //         'processAfterAuthorizationGetQuoteService'
  //       );
  //       const getQuoteInfoDialogRef = this.dialog.open(ModalGetQuoteInfoComponent, {
  //         width: '455px'
  //       });
  //       return getQuoteInfoDialogRef.afterClosed();
  //     }),
  //     concatMap(res => {
  //       console.log('res', res);
  //       if (res && res.zipCode && res.dealers && res.dealers.length) {
  //         const getQuoteDealersDialogRef = this.dialog.open(ModalGetQuoteDealersComponent, {
  //           width: '700px',
  //           data: {
  //             getAddress: this.getAddress.bind(this),
  //             dealers: res.dealers,
  //             comments: res.comments,
  //             projectUrl: `${environment.appUrl}/browsing/${this.projectManagerService.project.id}`,
  //             zipCode: res.zipCode,
  //             coords: res.coords
  //           }
  //         });
  //
  //         return getQuoteDealersDialogRef.afterClosed().pipe(
  //           switchMap(dealerChosenRes => {
  //             if (!dealerChosenRes.dealer) {
  //               return ErrorObservable.create('Warning no dealer chosen');
  //             }
  //             return of({ ...res, ...{ dealer: dealerChosenRes.dealer } });
  //           })
  //         );
  //       }
  //       return ErrorObservable.create('Warning no zip code or dealers');
  //     }),
  //     concatMap(res => {
  //       // console.log('res ModalQuoteSent service', res);
  //       const country =
  //         res.dealer &&
  //         res.dealer.values &&
  //         this.getAddress(res.dealer.values, 'country') &&
  //         this.getAddress(res.dealer.values, 'country')[0] &&
  //         this.getAddress(res.dealer.values, 'country')[0]['text']
  //           ? this.getAddress(res.dealer.values, 'country')[0]['text']
  //           : '';
  //
  //       const state =
  //         res.dealer &&
  //         res.dealer.values &&
  //         this.getAddress(res.dealer.values, 'state') &&
  //         this.getAddress(res.dealer.values, 'state')[0] &&
  //         this.getAddress(res.dealer.values, 'state')[0]['text']
  //           ? this.getAddress(res.dealer.values, 'state')[0]['text']
  //           : '';
  //
  //       const city = this.getAddress(res.dealer.values, 'city');
  //       const address1 = this.getAddress(res.dealer.values, 'address1');
  //       let dealerAddress = null;
  //       if (country && city && state && address1) {
  //         dealerAddress = `${country}, ${city}, ${state}, ${address1}`
  //       }
  //
  //       this.dialog.open(ModalQuoteSent, {
  //         width: '400px',
  //         data: {
  //           dealerCompanyName: res.dealer.values.companyname,
  //           dealerAddress
  //         }
  //       });
  //       this.analyticsService.onUserCreatedQuote(
  //         this.projectManagerService.project.id,
  //         res.dealer.name,
  //         res.comments
  //       );
  //       return of(true);
  //     })
  //   );
  // }

  constructor(
    private authService: AuthService,
    private projectManagerService: ProjectManagerService,
    private addonManagerService: AddonManagerService,
    private location: Location,
    private loadingSpinnerService: LoadingSpinnerService,
    private projectSaveService: ProjectSaveService,
    private toasterService: ToasterService,
    private dialog: MatDialog,
    private analyticsService: AnalyticsService
  ) {}

  getQuoteForAddon() {
    // this._processAfterAuthorizationForAddon();
    // console.log('this._isAuthorized()', this._isAuthorized());
    return combineLatest(this._isAuthorized()).pipe(
      take(1),
      concatMap(([authorized]) => {
        if (authorized) {
            return this._processAfterAuthorizationForAddon();
        } else {
          return this._processAuthorization().pipe(
            switchMap(() => this._processAfterAuthorizationForAddon())
          );
        }
      }),
      catchError(err => {
        return of(true);
      })
    );
  }

  getQuote() {
    return combineLatest(this._isAuthorized(), this._isNewProject()).pipe(
      take(1),
      concatMap(([authorized, isNewProject]) => {
        if (authorized) {
          if (isNewProject) {
            return this._processAfterAuthorization(isNewProject);
          } else {
            return this._processAfterAuthorization(isNewProject);
          }
        } else {
          return this._processAuthorization().pipe(
            switchMap(() => this._processAfterAuthorization(true))
          );
        }
      }),
      catchError(err => {
        return of(true);
      })
    );
  }

  getAddress(data, addressPath) {
    if (data[`address.${addressPath}`]) {
      return data[`address.${addressPath}`];
    } else {
      return data[`billingaddress.${addressPath}`];
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/services/get-quote.service.ts